/* Golf Guys V2 */
(() => {
  const theme = window.theme || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- USP-balk: op mobiel om de beurt tonen ---------- */
  $$('.usp-bar__list').forEach((list) => {
    const items = $$('.usp-bar__item', list);
    if (items.length < 2) return;
    const mq = window.matchMedia('(max-width: 749px)');
    const still = window.matchMedia('(prefers-reduced-motion: reduce)');
    let i = 0, timer = null;
    const show = () => items.forEach((it, n) => it.classList.toggle('is-active', n === i));
    const start = () => {
      clearInterval(timer);
      if (!mq.matches) { list.classList.remove('is-rotating'); items.forEach((it) => it.classList.remove('is-active')); return; }
      list.classList.add('is-rotating'); show();
      if (!still.matches) timer = setInterval(() => { i = (i + 1) % items.length; show(); }, 4000);
    };
    mq.addEventListener('change', start);
    start();
  });

  /* ---------- Panelen (menu en winkelwagen) ---------- */
  let lastFocus = null;
  const openDrawer = (drawer) => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const toggle = $(`[aria-controls="${drawer.id}"]`);
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    const focusable = $('button, a, input', drawer.querySelector('[role="dialog"]'));
    if (focusable) setTimeout(() => focusable.focus(), 50);
  };
  const closeDrawer = (drawer) => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    const toggle = $(`[aria-controls="${drawer.id}"]`);
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (lastFocus) lastFocus.focus();
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { openDrawer(document.getElementById(opener.dataset.drawerOpen)); return; }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('[data-drawer]')); return; }
    const cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle && theme.cartType === 'drawer' && $('[data-cart-drawer]')) {
      e.preventDefault();
      openDrawer($('[data-cart-drawer]'));
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('[data-drawer].is-open').forEach(closeDrawer);
    $$('details[data-close-outside][open]').forEach((d) => d.removeAttribute('open'));
  });

  /* Dropdowns sluiten bij klik buiten */
  document.addEventListener('click', (e) => {
    $$('details[data-close-outside][open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* Zoekbalk in header */
  const searchToggle = $('[data-toggle-search]');
  if (searchToggle) {
    searchToggle.addEventListener('click', () => {
      const panel = $('#header-search');
      const show = panel.hidden;
      panel.hidden = !show;
      searchToggle.setAttribute('aria-expanded', String(show));
      if (show) $('input[type="search"]', panel).focus();
    });
  }

  /* ---------- Winkelwagen ---------- */
  const sectionsToRender = () => {
    const ids = [];
    const drawer = $('[data-cart-drawer]');
    if (drawer) ids.push(drawer.closest('[id^="shopify-section-"]').id.replace('shopify-section-', ''));
    const page = $('[data-cart-page]');
    if (page) ids.push(page.closest('[id^="shopify-section-"]').id.replace('shopify-section-', ''));
    return ids;
  };

  const renderSections = (sections) => {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      const el = document.getElementById(`shopify-section-${id}`);
      if (!el || !html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById(`shopify-section-${id}`);
      if (!fresh) return;
      const wasOpen = el.querySelector('[data-cart-drawer]')?.classList.contains('is-open');
      el.innerHTML = fresh.innerHTML;
      if (wasOpen) el.querySelector('[data-cart-drawer]')?.classList.add('is-open');
    });
  };

  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
  };

  const toast = (msg) => {
    const t = document.createElement('div');
    t.className = 'toast';
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(() => t.remove(), 3500);
  };

  const addToCart = async (formData) => {
    const ids = sectionsToRender();
    if (ids.length) {
      formData.append('sections', ids.join(','));
      formData.append('sections_url', window.location.pathname);
    }
    const res = await fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || theme.strings.error);
    renderSections(data.sections);
    const cart = await (await fetch(`${theme.routes.cart}.js`)).json();
    updateCount(cart.item_count);
    return data;
  };

  const changeLine = async (line, quantity) => {
    const ids = sectionsToRender();
    const body = $('[data-cart-body]');
    $$('[data-cart-body]').forEach((b) => b.classList.add('is-loading'));
    try {
      const res = await fetch(theme.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: ids, sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || theme.strings.error);
      renderSections(data.sections);
      updateCount(data.item_count);
    } catch (err) {
      toast(err.message);
      if (body) body.classList.remove('is-loading');
    }
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const item = btn.closest('[data-line]');
    if (item) changeLine(Number(item.dataset.line), Number(btn.dataset.qtyChange));
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-qty-input]');
    if (input) {
      const item = input.closest('[data-line]');
      changeLine(Number(item.dataset.line), Math.max(0, parseInt(input.value, 10) || 0));
      return;
    }
    const note = e.target.closest('[data-cart-note]');
    if (note) {
      fetch(`${theme.routes.cart}/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }
  });

  /* Snel toevoegen vanaf productkaart */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    const fd = new FormData();
    fd.append('id', btn.dataset.quickAdd);
    fd.append('quantity', '1');
    try {
      await addToCart(fd);
      if (theme.cartType === 'drawer' && $('[data-cart-drawer]')) openDrawer($('[data-cart-drawer]'));
      else window.location.href = theme.routes.cart;
    } catch (err) {
      toast(err.message);
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });

  /* Productformulier */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form || theme.cartType !== 'drawer' || !$('[data-cart-drawer]')) return;
    e.preventDefault();
    const btn = $('[data-add-button]', form);
    const errorEl = $('[data-form-error]', form);
    const label = btn.textContent;
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = theme.strings.adding;
    if (errorEl) errorEl.hidden = true;
    try {
      await addToCart(new FormData(form));
      openDrawer($('[data-cart-drawer]'));
    } catch (err) {
      if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
    } finally {
      btn.removeAttribute('aria-disabled');
      btn.textContent = label;
    }
  });

  /* Aantal op productpagina */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const input = $('input', step.parentElement);
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.qtyStep));
  });

  /* ---------- Productpagina ---------- */
  const initGallery = (root) => {
    const gallery = $('[data-gallery]', root);
    if (!gallery) return null;
    const slides = $$('.gallery__slide', gallery);
    const thumbs = $$('[data-thumb]', gallery);
    const show = (mediaId) => {
      let found = false;
      slides.forEach((s) => {
        const active = s.dataset.mediaId === String(mediaId);
        s.classList.toggle('is-active', active);
        if (active) found = true;
      });
      if (!found) return;
      thumbs.forEach((t) => t.toggleAttribute('aria-current', t.dataset.thumb === String(mediaId)));
      const active = thumbs.find((t) => t.dataset.thumb === String(mediaId));
      if (active) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    const step = (dir) => {
      const i = slides.findIndex((s) => s.classList.contains('is-active'));
      const next = slides[(i + dir + slides.length) % slides.length];
      show(next.dataset.mediaId);
    };
    thumbs.forEach((t) => t.addEventListener('click', () => show(t.dataset.thumb)));
    $('[data-gallery-prev]', gallery)?.addEventListener('click', () => step(-1));
    $('[data-gallery-next]', gallery)?.addEventListener('click', () => step(1));
    let startX = null;
    const main = $('.gallery__main', gallery);
    main.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
      startX = null;
    });
    return show;
  };

  const initProduct = (root) => {
    const showMedia = initGallery(root);
    const picker = $('[data-variant-picker]', root);
    if (!picker) return;
    const variants = JSON.parse($('[data-variants]', picker).textContent);
    const form = $('[data-product-form]', root);
    const idInput = form ? $('[data-variant-id]', form) : null;
    const addBtn = form ? $('[data-add-button]', form) : null;
    const priceWrap = $('[data-price-wrapper]', root);

    const update = () => {
      const selected = $$('fieldset', picker).map((fs) => {
        const checked = $('input:checked', fs);
        const label = $('[data-option-selected]', fs);
        if (checked && label) label.textContent = checked.value;
        return checked ? checked.value : null;
      });
      const variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));

      // Beschikbaarheid per optiewaarde, gegeven de andere keuzes
      $$('fieldset', picker).forEach((fs, idx) => {
        $$('.option__value', fs).forEach((wrap) => {
          const value = $('input', wrap).value;
          const ok = variants.some((v) => v.available && v.options[idx] === value && v.options.every((o, i) => i === idx || o === selected[i]));
          wrap.classList.toggle('is-unavailable', !ok);
        });
      });

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = theme.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      }
      if (priceWrap) {
        const priceEl = $('[data-price]', priceWrap);
        if (priceEl) priceEl.outerHTML = variant.price;
      }
      if (variant.media && showMedia) showMedia(variant.media);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };
    picker.addEventListener('change', update);
    update();
  };

  $$('[data-product-section]').forEach(initProduct);

  /* Delen */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-share]');
    if (!btn) return;
    const data = { title: btn.dataset.title, url: btn.dataset.url };
    if (navigator.share) { try { await navigator.share(data); } catch (_) { /* geannuleerd */ } }
    else if (navigator.clipboard) { await navigator.clipboard.writeText(data.url); toast('Link gekopieerd'); }
  });

  /* Aanbevolen producten laden */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (_) { /* stil falen */ }
  });

  /* ---------- Collectie ---------- */
  document.addEventListener('change', (e) => {
    const auto = e.target.closest('[data-auto-submit]');
    if (auto && auto.form) auto.form.submit();
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-filter-form]');
    if (!form) return;
    // Lege prijsvelden niet meesturen
    $$('input[type="number"]', form).forEach((i) => { if (i.value === '') i.disabled = true; });
  });
  $$('[data-read-more]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = document.getElementById(btn.getAttribute('aria-controls'));
      const open = target.classList.toggle('is-clamped') === false;
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? btn.dataset.less || 'Minder tonen' : btn.dataset.more || 'Lees meer';
    });
  });

  /* Theme editor: secties opnieuw initialiseren */
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-product-section]', e.target).forEach(initProduct);
  });
})();
